// import { Injectable, InjectionToken } from '@angular/core';
// import { Firestore,  collectionData, addDoc, doc, updateDoc, deleteDoc, DocumentReference } from '@angular/fire/firestore';
// //import { collection, addDoc  } from 'firebase/firestore';
// import { getFirestore, collection, getDoc } from  '@angular/fire/firestore';
// import { Observable } from 'rxjs';

import { Injectable } from '@angular/core';
import { Firestore, collection, collectionData, addDoc, doc, updateDoc, deleteDoc, DocumentReference } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { catchError ,of } from 'rxjs';
import { runAsyncInInjectionContext } from './injection-context-utils';
import { inject, EnvironmentInjector } from '@angular/core';



@Injectable({ providedIn: 'root' })

export class FirebaseCrudService {
 private injector = inject(EnvironmentInjector);
  

  constructor(private firestore: Firestore) {
   
  }


  // async getFoodTypeByEvent() {

  //   const app = initializeApp(environment.firebase);
  //   // Initialize Cloud Firestore and get a reference to the service
  //   const db = getFirestore(app);
  //   const docRef = doc(db, "GetFoodByEvent",'NMVNN2AzqzQpLvDnsbBn');
  //   const docSnap = await getDoc(docRef);
  //   return docSnap.data()
  //  // return collectionData(docSnap.data, { idField: 'id' }) as Observable<any[]>;
  // }
  // async getFoodTypeByEvent(){
  //    const docRef = doc(this.firestore, "GetFoodByEvent", 'NMVNN2AzqzQpLvDnsbBn');
  //   // If you want to get the document data as a Promise:
  //   const snap = await getDoc(docRef);
  //   return snap.data();
  // }

  // ======= CRUD for FoodItems collection =======
  // addFoodItem(item: any): Promise<DocumentReference> {
 
  //   const foodItemsRef = collection(this.firestore, 'FoodItems');
  //   return addDoc(foodItemsRef, item);
    
  // }

  addFoodItem(item: any): Promise<DocumentReference | null> {
  const foodItemsRef = collection(this.firestore, 'FoodItems');
  return addDoc(foodItemsRef, item)
    .catch(error => {
      // Suppress the error, optionally log it
      // console.error(error);
      return null;
    });
}

  // getFoodItems(): Observable<any[]> {
  //   const foodItemsRef = collection(this.firestore, 'FoodItems');
  //   return collectionData(foodItemsRef, { idField: 'id' }) as Observable<any[]>;
  // }

  // updateFoodItem(id: string, data: any): Promise<void> {
  //   const itemDoc = doc(this.firestore, `FoodItems/${id}`);
  //   return updateDoc(itemDoc, data);
  // }

  // deleteFoodItem(id: string): Promise<void> {
  //   const itemDoc = doc(this.firestore, `FoodItems/${id}`);
  //   return deleteDoc(itemDoc);
  // }

  // ======= CRUD for FoodTypeByEvent collection =======
  // addFoodTypeByEvent(entry: any): Promise<DocumentReference> {
  //   const eventRef = collection(this.firestore, 'FoodTypeByEvent');
  //   return addDoc(eventRef, entry);
  // }

  // getFoodTypeByEvent(): Observable<any[]> {
  //   const eventRef = collection(this.firestore, 'FoodTypeByEvent');
  //   return collectionData(eventRef, { idField: 'id' }) as Observable<any[]>;
  // }

//   getFoodTypeByEvent(): Observable<any[]> {
//   const eventRef = collection(this.firestore, 'FoodTypeByEvent');
//   // Suppress all errors: if an error occurs, return an empty array
//   return collectionData(eventRef, { idField: 'id' })
//     .pipe(
//       // catchError will handle any thrown error and return an empty array instead
//       catchError(() => of([]))
//     ) as Observable<any[]>;
// }

 async getFoodTypeByEvent(): Promise<Observable<any[]>> {
  return await runAsyncInInjectionContext(this.injector, async () => {
    const eventRef = collection(this.firestore, 'FoodTypeByEvent');
    return collectionData(eventRef, { idField: 'id' })
      .pipe(
        catchError(() => of([]))
      ) as Observable<any[]>;
  });
}

 async addFoodTypeByEvent(entry: any): Promise<DocumentReference> {
  return await runAsyncInInjectionContext(this.injector, async () => {
    const eventRef = collection(this.firestore, 'FoodTypeByEvent');
    return addDoc(eventRef, entry);
      
  });
}

async deleteFoodTypeByEvent(id: string): Promise<void> {
  return await runAsyncInInjectionContext(this.injector, async () => {
       const entryDoc = doc(this.firestore, `FoodTypes/${id}`);
       return deleteDoc(entryDoc)
     
  });
}

 async getFoodItems(): Promise<Observable<any[]>> {
  return await runAsyncInInjectionContext(this.injector, async () => {
    const eventRef = collection(this.firestore, 'FoodItems');
    return collectionData(eventRef, { idField: 'id' })
      .pipe(
        catchError(() => of([]))
      ) as Observable<any[]>;
  });
}

 async addFoodItems(entry: any): Promise<DocumentReference> {
  return await runAsyncInInjectionContext(this.injector, async () => {
    const eventRef = collection(this.firestore, 'FoodItems');
    return addDoc(eventRef, entry);
      
  });
}

async deleteFoodItems(id: string): Promise<void> {
  return await runAsyncInInjectionContext(this.injector, async () => {
       const entryDoc = doc(this.firestore, `FoodMenu/${id}`);
       return deleteDoc(entryDoc)
     
  });
}




 async getLeads(): Promise<Observable<any[]>> {
  return await runAsyncInInjectionContext(this.injector, async () => {
    const eventRef = collection(this.firestore, 'SpiceTrailCatering');
    return collectionData(eventRef, { idField: 'id' })
      .pipe(
        catchError(() => of([]))
      ) as Observable<any[]>;
  });
}

 async addLeads(entry: any): Promise<DocumentReference> {
  return await runAsyncInInjectionContext(this.injector, async () => {
    const eventRef = collection(this.firestore, 'SpiceTrailCatering');
    return addDoc(eventRef, entry);
      
  });
}


async updateLeads(id: string, data: any): Promise<void> {
  return await runAsyncInInjectionContext(this.injector, async () => {
    const entryDoc = doc(this.firestore, `SpiceTrailCatering/${id}`);
    return updateDoc(entryDoc, data);
  });
}


 async getFoodMenu(): Promise<Observable<any[]>> {
  return await runAsyncInInjectionContext(this.injector, async () => {
    const eventRef = collection(this.firestore, 'FoodMenu');
    return collectionData(eventRef, { idField: 'id' })
      .pipe(
          catchError((err) => {
          console.error('Error fetching FoodMenu:', err);
          return of([]);
        })
      ) as Observable<any[]>;
  });
}

 async addFoodMenu(entry: any): Promise<DocumentReference> {
  return await runAsyncInInjectionContext(this.injector, async () => {
    const eventRef = collection(this.firestore, 'FoodMenu');
    return addDoc(eventRef, entry);
      
  });
}

async updateFoodMenu(id: string, data: any): Promise<void> {
  return await runAsyncInInjectionContext(this.injector, async () => {
    const entryDoc = doc(this.firestore, `FoodMenu/${id}`);
    return updateDoc(entryDoc, data);
  });
}

//  async getFoodTypes(): Promise<Observable<any[]>> {
//   return await runAsyncInInjectionContext(this.injector, async () => {
//     const eventRef = collection(this.firestore, 'FoodMenu');
//     return collectionData(eventRef, { idField: 'id' })
//       .pipe(
//           catchError((err) => {
//           console.error('Error fetching FoodMenu:', err);
//           return of([]);
//         })
//       ) as Observable<any[]>;
//   });
// }

  // updateFoodTypeByEvent(id: string, data: any): Promise<void> {
  //   const entryDoc = doc(this.firestore, `FoodTypeByEvent/${id}`);
  //   return updateDoc(entryDoc, data);
  // }

  // deleteFoodTypeByEvent(id: string): Promise<void> {
  //   const entryDoc = doc(this.firestore, `FoodTypeByEvent/${id}`);
  //   return deleteDoc(entryDoc);
  // }

 
  //For FoodTypes collection
    async addFoodType(drink: any): Promise<void> {
    return await runAsyncInInjectionContext(this.injector, async () => {
      const drinksCol = collection(this.firestore, 'FoodTypes');
      await addDoc(drinksCol, drink);
    });
  }

  async getFoodType():  Promise<Observable<any[]>> {
     return await runAsyncInInjectionContext(this.injector, async () => {
    const eventRef = collection(this.firestore, 'FoodTypes');
    return collectionData(eventRef, { idField: 'id' })
      .pipe(
          catchError((err) => {
          console.error('Error fetching FoodMenu:', err);
          return of([]);
        })
      ) as Observable<any[]>;
  });
  }


  async getEvents(): Promise<Observable<any[]>> {
    return await runAsyncInInjectionContext(this.injector, async () => {
      const eventRef = collection(this.firestore, 'Events');
      return collectionData(eventRef, { idField: 'id' })
        .pipe(
          catchError((err) => {
            console.error('Error fetching Events:', err);
            return of([]);
          })
        ) as Observable<any[]>;
    });
  }

     async addEvent(event: any): Promise<void> {
    return await runAsyncInInjectionContext(this.injector, async () => {
      const drinksCol = collection(this.firestore, 'Events');
      await addDoc(drinksCol, event);
    });
  }

  async deleteEvent(id: string): Promise<void> {
  return await runAsyncInInjectionContext(this.injector, async () => {
       const entryDoc = doc(this.firestore, `Events/${id}`);
       return deleteDoc(entryDoc)
     
  });
}

  async updateEvent(id: string, data: any): Promise<void> {
    return await runAsyncInInjectionContext(this.injector, async () => {
      const entryDoc = doc(this.firestore, `Events/${id}`);
      return updateDoc(entryDoc, data);
    });
  }

   async updateFoodType(id: string, data: any): Promise<void> {
    return await runAsyncInInjectionContext(this.injector, async () => {
      const entryDoc = doc(this.firestore, `FoodTypes/${id}`);
      return updateDoc(entryDoc, data);
    });
  }


}